/** Turn a prompt cover path from the API into a URL the browser can load. */
export function promptCoverSrc(src: string | null | undefined): string {
  if (!src) return "";
  if (
    src.startsWith("data:") ||
    src.startsWith("blob:") ||
    src.startsWith("http://") ||
    src.startsWith("https://")
  ) {
    return src;
  }
  const base = String(process.env.REACT_APP_SERVER_BASE_URL || "").replace(/\/$/, "");
  return `${base}${src.startsWith("/") ? src : `/${src}`}`;
}
